import { useState, useCallback, useEffect } from 'react';
import { attendanceFollowUpsApi } from '../../../services/api/attendanceFollowUps';
import type { AttendanceFollowUpSummary } from '../../../services/api/attendanceFollowUps';

interface UseFollowUpSummaryOptions {
  cohortId: string;
  enabled?: boolean;
}

interface UseFollowUpSummaryResult {
  summary: AttendanceFollowUpSummary | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useFollowUpSummary({
  cohortId,
  enabled = true,
}: UseFollowUpSummaryOptions): UseFollowUpSummaryResult {
  const [summary, setSummary] = useState<AttendanceFollowUpSummary | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchSummary = useCallback(async () => {
    if (!enabled || !cohortId) return;
    try {
      setLoading(true);
      const data = await attendanceFollowUpsApi.summary(cohortId);
      setSummary(data);
    } catch {
      // Silently fail — banners just won't show
    } finally {
      setLoading(false);
    }
  }, [cohortId, enabled]);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  return { summary, loading, refresh: fetchSummary };
}
